import React, { useCallback, useEffect, useState } from 'react';
import {
  Button, Form, Grid, Icon, Loader
} from 'semantic-ui-react';
import {
  createInvoiceItem,
  saveShipmentFieldValue,
  updateShipmentFieldValue,
  saveInvoiceLineItemFeild,
} from '../../actions'
import InvoiceItemList from "./InvoiceItemList";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../../../commonComponents/formComponents/inputField";
import DropDown from '../../../commonComponents/formComponents/dropDown'
import ErrorMessagesWindow from "@commonComponents/errorValidationWindow";
import { useUpdateEffect } from '../../../hooks';
import { convertedDataItemsTab } from '../../util/helper';
import { intializeItemsTabWarnings} from '../../../commonActions/serverErrorAction'
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType';
import usePdiEnable from '../../hooks/usePdiEnable';
import getSymbolFromCurrency from 'currency-symbol-map';
import {CURRENCY_CODE} from '../../Helper/formLabel';
import { getValidationError as ValidationError } from '../../Helper';
import { addItemsTabWarnings, deleteItemsTabWarnings } from '../../../commonActions/serverErrorAction';





function InvoiceForm(props) {
  const dispatch = useDispatch();
  const ErrorWarningsList = useSelector((state) => state.ServerErrorReducer?.itemsTab) || []

 
  const totalItem = useSelector((state) => state.Shipment.totalItem);
  const totalInvoiceAmountInCurrency = useSelector((state) => state.Shipment.totalInvoiceAmountInCurrency)
  const totalGrassWeight = useSelector((state) => state.Shipment.totalGrassWeight);
  const totalNetWeight = useSelector((state) => state.Shipment.totalNetWeight);

  const totalInvoice = useSelector((state) => state.Shipment.totalInvoice); 
  const totalShipmentPackages = useSelector((state) => state.Shipment.totalShipmentPackages); 
  const declarationTypeValue = useSelector((state) => state.Shipment.declarationType);
  const shipmentCurrency = useSelector((state) => state.Shipment.shipmentCurrency);
  const currencyCodes = useSelector((state) => state.DropDownValues.currencyCodes)

  const getValidationError=(field, value, Level, onlyMandatoryCheck=false)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate)

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }
  // const invoiceId = useSelector((state) => state.InvoicesReducer.invoices[0]?.invoiceId);

  const formData = useSelector((state) => state.Shipment)

  const [isAdding, setIsAdding] = useState(false);
  const { jobWheels,customJobState } = useCurrentShipmentType()
  const pdiValidationCheck = customJobState?.includes("PDI");
  const   updateAddStatus = useCallback(
    () => {
      setIsAdding(false);
    },
    [isAdding],
  )
        const{isFormDisabled,translate,serviceType} = props;

        useEffect(()=>{
          const completeData = convertedDataItemsTab(formData,'itemsTab',translate,true,serviceType,pdiValidationCheck);
          dispatch(intializeItemsTabWarnings('itemsTab', completeData))
        },[translate])

  useEffect(() => {
    if (!totalInvoiceAmountInCurrency && shipmentCurrency) {
      dispatch(saveShipmentFieldValue('shipmentCurrency'))
    }
  }, [])
        
  const formDisabled = true
  


  const isPdi = pdiValidationCheck
        return (
          <div className='formContentareaC88 headerDetails'>
            {ErrorWarningsList?.length > 0 && !props.disabled && (
              <ErrorMessagesWindow errors={ErrorWarningsList} />
            )}
            <div style={{ width: '100.5%', marginTop: '20px', marginLeft: '20px' }}>
              <Form.Group className='float-container'>
                <Grid>
                  <Grid.Row>
                    <Grid.Column
                      width='4'
                      className='divFormFeild border-bottom b-rw-0 b-blr-5 b-tlr-5'
                    >
                      <InputField
                        isLabel={false}
                        id={`totalInvoice`}
                        type='number'
                        label={translate('TOTAL_INVOICES', { ns: ['default', 'lineItem'] })}
                        boxNumber='22'
                        className={'field-bg'}
                        value={totalInvoice}
                        clearInput={false}
                        disabled={formDisabled}
                      />
                    </Grid.Column>
                    <Grid.Column width='4' className='divFormFeild  border-bottom b-rw-0 '>
                      <InputField
                        isLabel={false}
                        id={`totalItem`}
                        type='number'
                        label={translate('TOTAL_ITEMS', { ns: ['default', 'lineItem'] })}
                        boxNumber='22'
                        className={'field-bg'}
                        value={totalItem}
                        clearInput={false}
                        disabled={formDisabled}
                      />
                    </Grid.Column>
                    <Grid.Column width='4' className='divFormFeild  border-bottom b-rw-0 '>
                      <InputField
                        isLabel={false}
                        id={`totalInvoiceAmount`}
                        type='number'
                        label={translate('TOTAL_INVOICE_AMT', { ns: ['default', 'lineItem'] })}
                        boxNumber='22'
                        className={'field-bg'}
                        value={totalInvoiceAmountInCurrency}
                        // string={
                        //   currency ? getSymbolFromCurrency(currency) : getSymbolFromCurrency('EUR')
                        // }
                        // string={'€'}
                        addThousandsSeperator={true}
                        clearInput={false}
                        disabled={formDisabled}
                        onChange={(value) => {
                          dispatch(updateShipmentFieldValue('totalInvoiceAmount', value))
                        }}
                        onBlur={(value) => {
                          dispatch(saveShipmentFieldValue('totalInvoiceAmount'))
                        }}
                      />
                    </Grid.Column>
                    <Grid.Column
                        width='3'
                        className='divFormFeild'
                      >
                        <DropDown
                          id={'currencyCode'}
                          label={translate(CURRENCY_CODE, { ns: ['default', 'lineItem'] })}
                          disabled={isFormDisabled}
                          className='field-bg dropdown100'
                          labelClass='text-none'
                          isLabel={true}
                          direction={'left'}
                          data={currencyCodes}
                          // errors={getValidationError('currency', currency, 'itemsTab',true)}
                          value={shipmentCurrency}
                          onChange={(value) => {
                            dispatch(updateShipmentFieldValue({shipmentCurrency: value?.trim()})), 
                            dispatch(saveShipmentFieldValue('shipmentCurrency'))
                          }}
                          //   let err = getValidationError('currency', value, 'itemsTab', true)
                          //   err.length
                          //     ? addErrors(
                          //         'itemsTab',
                          //         `invoice -00${invoiceItemIndex + 1}` + ' :: ' + err[0],
                          //         `currency-${invoiceId}`
                          //       )
                          //     : deleteErrors('itemsTab', '', `currency-${invoiceId}`)

                          // }}

                        />
                      </Grid.Column>
                    </Grid.Row>
                    
                    <Grid.Row>
                    <Grid.Column width={isPdi ? '4' : '5'} className='divFormFeild border-bottom b-rw-0 b-blr-5 b-tlr-5'>
                      <InputField
                        isLabel={false}
                        id={`totalShipmentPackages`}
                        type='number'
                        label={translate('TOTAL_PACKAGES', { ns: ['default', 'lineItem'] })}
                        boxNumber='6'
                        className={'field-bg'}
                        value={totalShipmentPackages}
                        clearInput={false}
                        disabled={formDisabled}
                        onChange={(value) => {
                          dispatch(updateShipmentFieldValue('totalShipmentPackages', value))
                        }}
                        onBlur={(value) => {
                          dispatch(saveShipmentFieldValue('totalShipmentPackages'))
                        }}
                      />
                    </Grid.Column>
                    <Grid.Column
                      width={isPdi ? '4' : '5'}
                      className='divFormFeild border-bottom  b-rw-0 '
                    >
                      <InputField
                        isLabel={false}
                        id={`totalNetWeight`}
                        type='number'
                        label={translate('TOTAL_NET_WT', { ns: ['default', 'lineItem'] })}
                        boxNumber='6'
                        className={'field-bg'}
                        value={totalNetWeight}
                        clearInput={false}
                        disabled={formDisabled}
                      />
                    </Grid.Column>
                    <Grid.Column
                      width={isPdi ? '4' : '5'}
                      className={`divFormFeild border-bottom ${
                        isPdi ? 'b-rw-0' : 'b-rw-1  b-brr-5 b-trr-5'
                      }`}
                    >
                      <InputField
                        isLabel={false}
                        id={`totalGrassWeight`}
                        type='text'
                        boxNumber='6'
                        label={translate('TOTAL_GROSS_WT', { ns: ['default', 'lineItem'] })}
                        value={totalGrassWeight}
                        className={'field-bg'}
                        clearInput={false}
                        disabled={formDisabled}
                      />
                    </Grid.Column>
                    {isPdi && (
                      <Grid.Column
                        width='3'
                        className='divFormFeild border-bottom  b-brr-5 b-trr-5'
                      >
                        <InputField
                          isLabel={false}
                          id={`pdiItems`}
                          type='text'
                          boxNumber='5'
                          label={translate('TOTAL_PDI_ITEMS', { ns: ['default', 'lineItem'] })}
                          value={totalItem}
                          className={'field-bg'}
                          clearInput={false}
                          disabled={formDisabled}
                        />
                      </Grid.Column>
                      
                    )}
                    
                  </Grid.Row>
                </Grid>
              </Form.Group>
            </div>
            {
              <InvoiceItemList
                isFormDisabled={isFormDisabled}
                declarationTypeValue={declarationTypeValue}
                translate={translate}
                jobWheels={props.jobWheels}
              />
            }
            <div style={{ marginLeft: '10px' }}>
              <Button
                basic
                color='blue'
                className='btn-add-item'
                id={`addInvoice`}
                onClick={() => {
                  setIsAdding(true)

                  dispatch(createInvoiceItem(totalItem, totalInvoice, updateAddStatus))
                }}
                disabled={isFormDisabled || isAdding}
              >
                {!isAdding ? (
                  <span>
                    <Icon name='add circle' disabled={isFormDisabled} />
                    {translate('ADD_INVOICE', { ns: ['default', 'lineItem'] })}
                  </span>
                ) : (
                  <span>
                    <Loader active inline size='mini' style={{ marginRight: '10px' }} />
                    {translate('ADDING_INVOICE', { ns: ['default', 'lineItem'] })}
                  </span>
                )}
              </Button>
            </div>
          </div>
        )
    
}

export default React.memo(InvoiceForm)

